<template>
  <div class="edit-predicted-with-actual-popup-flow">
    <edit-predicted-transaction v-if="componentIndex === 0"
                                      :predicted-transaction="predictedTransaction"
                                      :close-action="closeAction"
                                      :next-action="next"
                                      :fixed-expense-categories="fixedExpenseCategories"
                                      :set-new-expense-category="setNewExpenseCategory" />

    <edit-predicted-transaction-summary v-else
                                      :predicted-transaction="predictedTransaction"
                                      :back-action="back"
                                      :close-action="closeAction"
                                      :old-expense-category="oldExpenseCategory"
                                      :new-expense-category="newExpenseCategory" />
  </div>
</template>

<script>
import _ from 'lodash';
import Segment from '../../../../../../../../../../../../Segment';
import EditPredictedTransaction from '../EditPredictedTransaction.vue';
import EditPredictedTransactionSummary from '../EditPredictedTransactionSummary.vue';
import consts from '../../../../../../../../../../../../constants/cashflow-view';

export default {
  name: 'EditPredictedWithActualFlow',
  components: {
    EditPredictedTransaction,
    EditPredictedTransactionSummary,
  },
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentIndex: 0,
      oldExpenseCategory: this.predictedTransaction.expense,
      newExpenseCategory: null,
    };
  },
  computed: {
    fixedExpenseCategories() {
      if (_.includes(consts.NON_TRANSFERABLE_FIXED_EXPENSE_CATEGORIES, this.predictedTransaction.expense)) {
        return _.concat(this.predictedTransaction.expense, consts.TRANSFERABLE_FIXED_EXPENSE_CATEGORIES);
      }
      return consts.TRANSFERABLE_FIXED_EXPENSE_CATEGORIES;
    },
  },
  methods: {
    setNewExpenseCategory(newExpenseCategory) {
      this.newExpenseCategory = newExpenseCategory;
    },
    closeAction() {
      Segment.trackUserInteraction('EditPredictedWithActualFlow_Closed', {
        predictedTransaction: this.predictedTransaction,
      });
      this.$emit('close');
    },
    back() {
      this.componentIndex = 0;
    },
    next() {
      this.componentIndex = 1;
    },
  },
};
</script>
